export enum RegistrationEvent {
  REG_INIT = 'RegistrationInitatedEvent',
  REG_INTERACTED = 'RegistrationInteractionEvent',
  REG_TOGGLE_REFERRAL_INPUT = 'RegistrationToggleReferralInputEvent',
  REG_COMPLETED = 'RegistrationCompletedEvent',
  REG_FAILURE = 'RegistrationFailureEvent',
  REG_ABANDONED = 'RegistrationAbandondedEvent',
  PARTIAL_REG_STEP_ONE = 'PartialRegistrationStepOneEvent',
  PARTIAL_REG_STEP_TWO = 'PartialRegistrationStepTwoEvent',
  PARTIAL_REG_STEP_THREE = 'PartialRegistrationStepThreeEvent',
  PARTIAL_REG_FAILURE = 'PartialRegistrationFailureEvent',
  PARTIAL_REG_REQUEST_NEW_OTP = 'PartialRegistrationRequestNewOtpEvent',
  PARTIAL_REG_SUCCESS = 'PartialRegistrationSuccessEvent',
  REG_SUCCESS = 'RegistrationSuccessEvent',
}
